/**
 * 정산 월별 상세 단독 페이지 (/settlement/:id/:yearMonth)
 *
 *  본문은 정산 목록 우측 패널과 동일한 컴포넌트를 그대로 사용한다. (딥링크·기존 북마크 호환)
 *  companySeq 는 라우터 state 로만 전달되므로, state 가 없으면 목록에서 다시 선택하도록 안내한다.
 */
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { PageHeader } from '@/components/common';
import { SettlementDetailPanel } from './SettlementDetailPanel';

interface NavState {
  companySeq?: number;
  companyName?: string;
  businessNumber?: string;
}

export function SettlementDetailPage() {
  const { id, yearMonth } = useParams<{ id: string; yearMonth: string }>();
  const navigate = useNavigate();
  const location = useLocation();
  const navState = (location.state ?? {}) as NavState;

  const decodedId = id ? decodeURIComponent(id) : '';
  const decodedYearMonth = yearMonth ? decodeURIComponent(yearMonth) : '';

  return (
    <div className="flex h-[calc(100vh-120px)] flex-col">
      <div className="shrink-0">
        <PageHeader
          title="정산 월별 상세"
          subtitle={`${navState.companyName ? `${navState.companyName} · ` : ''}${decodedYearMonth} 기준 결제/정산 내역입니다.`}
          right={
            <button
              type="button"
              onClick={() => navigate('/settlement')}
              className="inline-flex items-center gap-1 rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50"
            >
              <ArrowLeft size={16} />
              목록으로
            </button>
          }
        />
      </div>

      <div className="mt-4 min-h-0 flex-1">
        {navState.companySeq == null || !decodedYearMonth ? (
          <div className="flex h-full items-center justify-center rounded-lg border border-dashed border-gray-300 bg-white">
            <div className="text-center">
              <div className="text-sm text-gray-500">
                이 주소만으로는 정산 대상을 특정할 수 없습니다.
                <br />
                정산 정보 목록에서 다시 선택해 주세요.
              </div>
              <button
                type="button"
                onClick={() => navigate('/settlement')}
                className="mt-3 rounded-md border border-gray-300 bg-white px-3 py-1.5 text-xs text-gray-700 hover:bg-gray-50"
              >
                정산 정보로 이동
              </button>
            </div>
          </div>
        ) : (
          <SettlementDetailPanel
            target={{
              companySeq: navState.companySeq,
              yearMonth: decodedYearMonth,
              id: decodedId || undefined,
              companyName: navState.companyName,
              businessNumber: navState.businessNumber,
            }}
          />
        )}
      </div>
    </div>
  );
}

export default SettlementDetailPage;
